
import Vue from 'vue';
import Component from 'vue-class-component';
import { BoListPanel } from 'bonomo/dist';
import { namespace } from 'vuex-class';
import {IScreensaverLog, IUserLog} from '@/model/logs/Ilogs';
import { Prop } from 'vue-property-decorator';
import { BetterDataTableHeader } from '@/model/betterVuetifyInterfaces';
import {IScreensaver} from "@/model/Screensaver/screensaverInterfaces";

const screensaverModule = namespace('screensaverModule');

@Component({
  name: 'ScreensaverLogs',
  components: {
    BoListPanel,
  },
})
export default class ScreensaverLogs extends Vue {
  @Prop({default: 0})
  protected screensaverId!: number;

  @Prop({default: 0})
  protected lockerId!: number;

  @Prop({default: false})
  protected startExpanded!: boolean;

  @screensaverModule.Action('fetchLogs')
  private fetchLogs!: ({ filters }: any) => IUserLog;
  @screensaverModule.Action('fetchScreensaverLogs')
  private fetchScreensaverLogs!: ({ screensaverId, filters }: any) => IUserLog;
  @screensaverModule.Action('fetchLockerScreensaversLogs')
  private fetchLockerScreensaversLogs!: ({ lockerId, filters }: any) => IUserLog;
  @screensaverModule.Action('clearLogs')
  private clearLogs!: () => null;
  @screensaverModule.Getter('screensavers')
  private screensavers!: IScreensaver[];
  @screensaverModule.Getter('logs')
  private logs!: IScreensaverLog[];

  protected loading: boolean = false;
  protected expanded: boolean = false;

  protected get getTitle() {
    return this.screensaverId ? this.$t('screen_savers.logs.singleSsTitle') : this.$t('screen_savers.logs.title')
  }

  protected get headers(): BetterDataTableHeader[] {
    return [
      {
        text: this.$t('common.when'),
        align: 'start',
        sortable: false,
        value: 'created_at',
      },
      {
        text: this.$t('common.name'),
        align: 'start',
        sortable: false,
        value: 'screensaver_id',
      },
      {
        text: this.$t('common.description'),
        align: 'start',
        sortable: false,
        value: 'action',
      },
      {
        text: this.$t('common.details'),
        align: 'start',
        sortable: false,
        value: 'data',
      },
    ];
  }

  protected created()
  {
    this.expanded = this.startExpanded;
  }

  private loadData(filters: any) {
    if (this.lockerId) {
      this.fetchLockerScreensaversLogs({ lockerId: this.lockerId, filters });
    }
    else if (this.screensaverId) {
      this.fetchScreensaverLogs({ screensaverId: this.screensaverId, filters });
    } else {
      this.fetchLogs({filters});
    }
  }

  protected screensaverName(id: number): string {
    const screensaver = this.screensavers.find(each => each.id == id);
    return screensaver ? screensaver.name : ''+id;
  }

}
